<template>
  <div class="card card-box" style="border-radius : 0%; min-height: 650px;">
    <div
      class="card-body p-5 d-flex flex-column justify-content-between"
      style="padding-top: 30px !important"
    >
      <div class="row">
        <div class="col">
          <b-form-group
            id="fieldset-1"
            label-for="input-1"
            valid-feedback=""
            :invalid-feedback="invalidFeedbackUsername"
            :state="stateUsername"
          >
            <template slot="label">
              Username<span style="color:red">*</span>
            </template>
            <b-form-input
              :disabled="btnDisable"
              id="input-1"
              v-model="username"
              :state="stateUsername"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col">
          <b-form-group
            id="fieldset-1"
            label-for="input-1"
            valid-feedback=""
            :invalid-feedback="invalidFeedbackPassword"
            :state="statePassword"
          >
            <template slot="label">
              Password<span style="color:red">*</span>
            </template>
            <b-input-group>
              <template #append>
                <b-input-group-text
                  :class="btnDisable ? 'disabled' : ''"
                  @click="
                    !btnDisable ? (passwordVisible = !passwordVisible) : true
                  "
                >
                  <font-awesome-icon
                    v-if="passwordVisible == false"
                    :icon="['fas', 'eye-slash']"
                  />
                  <font-awesome-icon v-else :icon="['fas', 'eye']" />
                </b-input-group-text>
              </template>
              <b-form-input
                id="input-1"
                v-model="password"
                :state="statePassword"
                :type="passwordVisible ? 'text' : 'password'"
                :disabled="btnDisable"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <b-button
            variant="success"
            v-if="!btnDisable"
            class="float-right"
            @click="onSubmit"
            >SIMPAN</b-button
          >
          <b-button
            variant="primary"
            v-if="btnDisable"
            @click="btnDisable = false"
            class="float-right"
            >EDIT DATA</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { EventBus } from "../../../event-bus";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

library.add(faEye, faEyeSlash);

export default {
  components: {},
  data() {
    return {
      username: null,
      password: null,
      passwordFieldType: "password",
      btnDisable: true,
      passwordVisible: false,
      dokterId: null
    };
  },
  created() {},
  mounted() {
    this.getProfile();
  },
  computed: {
    ...mapGetters(["getKlinikId", "getRolesName", "getFaskesType"]),
    isPic() {
      return /pic/.test(this.getRolesName);
    },
    isDokter() {
      return /dokter/.test(this.getRolesName);
    },
    isDpm() {
      return this.getFaskesType;
    },
    stateUsername() {
      if (this.username === null || this.btnDisable == true) {
        return null;
      }

      if (this.username.length === 0) {
        return false;
      }

      return true;
    },
    invalidFeedbackUsername() {
      if (this.username === null) {
        return "";
      }

      if (this.username.length === 0) {
        return "Tolong Diisi";
      }

      return "";
    },
    statePassword() {
      if (this.password === null || this.btnDisable == true) {
        return null;
      }

      if (this.password.length === 0) {
        return false;
      }

      return true;
    },
    invalidFeedbackPassword() {
      if (this.password === null) {
        return "";
      }

      if (this.password.length === 0) {
        return "Tolong Diisi";
      }

      return "";
    }
  },
  methods: {
    onSubmit() {
        this.$swal
        .fire({
          type: "warning",
          html:
            '<p class="m-0 text-bridging-bpjs">Apakah Anda yakin akan <br>melakukan Bridging I-Care?</p>',
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#1791EE",
        })
        .then(res => {
          if (res.value) {
            this.btnDisable = true;
            this.submit();
          }
        });
    },
    async submit() {
      const res = await this.$axios.post(`bpjs/icare/bridging`, {
        username: this.username,
        password: this.password,
        dokter_id: this.dokterId,
        klinik_id: this.getKlinikId
      });

      const { status } = res.data;
      if (status) {
        this.$store.commit("SET_BRIDGING_ICARE", true);
        this.$swal({
          type: "success",
          html: '<p class="m-0 text-bridging-bpjs">Bridging I-Care Berhasil</p>'
        });
      } else {
        this.btnDisable = false;
        this.$swal({
          type: "error",
          html:
            '<p class="m-0 text-bridging-bpjs">Bridging I-Care Gagal! <br> Mohon cek kembali data konfigurasi atau hubungi PIC kantor cabang BPJS Anda!</p>'
        });
      }
    },
    togglePasswordVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
    async getProfile() {
      try {
        const res = await this.$axios.get(
          `klinik/user/${this.$store.state.user.id}?klinik_id=${this.getKlinikId}`
        );

        const { data } = res.data;
        const pivot = data.dokter[0].dokter_pv_klinik_bpjs[0];

        this.dokterId = data.dokter[0].id;

        if (pivot && pivot.bridging_icare == 1) {
          this.username = pivot.icare_username;
          this.password = pivot.icare_password;
        }

        EventBus.$emit("count-schedule", 0);

        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      } catch (error) {
      }
    }
  }
};
</script>

<style>
.input-group-text {
  background-color: transparent;
}

.input-group-text.disabled {
  background-color: #eeeff8;
}
</style>
